<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div class="flex flex-col shadow bg-card">
        <!-- Header -->
        <div
            class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
            <div class="flex-1 min-w-0">
                <!-- Breadcrumbs -->
                <div class="flex flex-wrap items-center font-medium">
                    <div>
                        <a class="whitespace-nowrap text-primary-500" [routerLink]="['/s']">Find A Contractor</a>
                    </div>
                    <div class="flex items-center ml-1 whitespace-nowrap">
                        <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'">
                        </mat-icon>
                        <a class="ml-1 text-primary-500">Profile</a>
                    </div>
                </div>
                <!-- Title -->
                <!-- <div class="mt-2">
                        <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                            Price Quote Form
                        </h2>
                    </div> -->
            </div>
        </div>
        <!-- Cover image -->
        <div>
            <img *ngIf="profile.cover_img_name" class="h-40 lg:h-80 object-cover"
                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/cover/' + profile.cover_img_name  }}"
                alt="Cover image">
            <img *ngIf="!profile.cover_img_name" class="h-40 lg:h-80 object-cover"
                src="assets/images/pages/profile/cover_2.jpg" alt="Cover image">
        </div>

        <!-- User info -->
        <div class="flex flex-col flex-0 lg:flex-row items-center max-w-5xl w-full mx-auto px-8 lg:h-18 bg-card">

            <!-- Avatar -->
            <div class="-mt-26 lg:-mt-22 rounded-full">
                <img *ngIf="profile.profile_img_name" class="w-32 h-32 rounded-full ring-4 ring-bg-card"
                    src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/profile/' + profile.profile_img_name  }}"
                    alt="User avatar">
                <img *ngIf="!profile.profile_img_name" class="w-32 h-32 rounded-full"
                    src="assets/images/logo/eseel_logo_hire_user.png" alt="Card profile image">
            </div>

            <!-- Details -->
            <div class="flex flex-col items-center lg:items-start mt-4 lg:mt-0 lg:ml-8">
                <div class="text-lg font-bold leading-none">{{profile.title}}</div>
                <div class="text-secondary">{{profile.store.city}}, {{profile.store.province}}</div>
            </div>

            <!-- Separator -->
            <div class="hidden lg:flex h-8 mx-8 border-l-2"></div>

            <!-- Stats -->
            <div class="flex items-center mt-6 lg:mt-0 space-x-6">
                <div class="flex flex-col items-center">
                    <ng-container>
                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:badge-check'"
                            [matTooltip]="'Verified business'">
                        </mat-icon>
                    </ng-container>
                    <!-- <span class="font-bold">200k</span>
                    <span class="text-sm font-medium text-secondary">FOLLOWERS</span> -->
                </div>

                <!-- <div class="flex flex-col items-center">
                    <span class="font-bold">1.2k</span>
                    <span class="text-sm font-medium text-secondary">FOLLOWING</span>
                </div> -->
            </div>

            <!-- Menu -->
            <!-- <div class="flex items-center mt-8 mb-4 lg:m-0 lg:ml-auto space-x-6">
                <a
                    class="font-medium"
                    [routerLink]="['./']">
                    Home
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    About
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    Followers
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    Gallery
                </a>
            </div> -->

        </div>

    </div>

    <!-- Main -->
    <div class="flex flex-auto justify-center w-full max-w-5xl mx-auto p-6 sm:p-8">

        <!-- Column -->
        <div class="hidden lg:flex flex-col items-start mr-8">

            <!-- About me -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full p-8">
                <div class="text-2xl font-semibold leading-tight">About Me</div>
                <div class="mt-4">
                    I’m a friendly kitchen assistant who suffers from a severe phobia of buttons.
                    <br><br>
                    Brother of Elijah Jay Watkins, who has phobia of buttons and trust issues.
                </div>
                <hr class="w-full border-t my-6">
                <div class="flex flex-col">
                    <div class="flex items-center">
                        <mat-icon
                            class="icon-size-5 mr-3"
                            [svgIcon]="'heroicons_solid:location-marker'"></mat-icon>
                        <span class="leading-none">London, UK</span>
                    </div>
                    <div class="flex items-center mt-4">
                        <mat-icon
                            class="icon-size-5 mr-3"
                            [svgIcon]="'heroicons_solid:briefcase'"></mat-icon>
                        <span class="leading-none">ACME Corp. Lead UX Designer</span>
                    </div>
                    <div class="flex items-center mt-4">
                        <mat-icon
                            class="icon-size-5 mr-3"
                            [svgIcon]="'heroicons_solid:cake'"></mat-icon>
                        <span class="leading-none">April, 24</span>
                    </div>
                </div>
                <button
                    class="px-6 mt-8"
                    mat-flat-button
                    [color]="'primary'"
                    [routerLink]="['./']">
                    See complete bio
                </button>
            </fuse-card> -->

            <!-- Followers -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4">
                <div class="flex items-center justify-between">
                    <div class="text-2xl font-semibold leading-tight">Followers</div>
                    <div class="-mr-3">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="listCard08Menu">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                        </button>
                        <mat-menu #listCard08Menu="matMenu">
                            <button mat-menu-item>Find friends</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="flex justify-between mt-6">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-01.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-01.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-02.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-02.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-03.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-04.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-03.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-04.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-05.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-06.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-05.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-06.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-07.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-07.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/male-08.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded-full"
                            src="assets/images/avatars/female-08.jpg"
                            alt="Card cover image">
                    </div>
                </div>
                <div class="flex items-center mt-6 -mx-3">
                    <button
                        class="px-3"
                        mat-button
                        [color]="'primary'"
                        [routerLink]="['./']">
                        See all followers
                    </button>
                </div>
            </fuse-card> -->

            <!-- Gallery -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4">
                <div class="flex items-center justify-between">
                    <div class="text-2xl font-semibold leading-tight">Gallery</div>
                    <div class="-mr-3">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="listCard09Menu">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                        </button>
                        <mat-menu #listCard09Menu="matMenu">
                            <button mat-menu-item>Add image</button>
                            <button mat-menu-item>Add video</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="flex justify-between mt-6">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/14-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/15-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/16-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/17-640x480.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/18-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/19-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/20-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/21-640x480.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/22-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/23-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/24-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/25-640x480.jpg"
                            alt="Card cover image">
                    </div>
                    <div class="flex justify-between mt-3">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/26-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/27-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/28-640x480.jpg"
                            alt="Card cover image">
                        <img
                            class="w-14 h-14 rounded object-cover"
                            src="assets/images/cards/29-640x480.jpg"
                            alt="Card cover image">
                    </div>
                </div>
                <div class="flex items-center mt-6 -mx-3">
                    <button
                        class="px-3"
                        mat-button
                        [color]="'primary'"
                        [routerLink]="['./']">
                        See entire gallery
                    </button>
                </div>
            </fuse-card> -->

            <!-- Groups -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4">
                <div class="flex items-center justify-between">
                    <div class="text-2xl font-semibold leading-tight">Groups</div>
                    <div class="-mr-3">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="listCard02Menu">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                        </button>
                        <mat-menu #listCard02Menu="matMenu">
                            <button mat-menu-item>Search for groups</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-col mt-5">
                    <div class="flex items-center">
                        <img
                            class="w-14 h-14 mr-4 rounded object-cover"
                            src="assets/images/cards/coffee-shop-01-320x200.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="font-medium leading-none">The Port Cafe</div>
                            <div class="text-md truncate leading-none mt-1">Best cafe of the downtown New York</div>
                            <div class="text-md leading-none text-secondary mt-2">1.2k followers</div>
                        </div>
                    </div>
                    <div class="flex items-center mt-6">
                        <img
                            class="w-14 h-14 mr-4 rounded object-cover"
                            src="assets/images/cards/coffee-shop-02-512x512.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="font-medium leading-none">Design House LLC.</div>
                            <div class="text-md truncate leading-none mt-1">UI/UX, brand and product design</div>
                            <div class="text-md leading-none text-secondary mt-2">957 followers</div>
                        </div>
                    </div>
                    <div class="flex items-center mt-6">
                        <img
                            class="w-14 h-14 mr-4 rounded object-cover"
                            src="assets/images/cards/coffee-shop-03-320x320.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="font-medium leading-none">Crax Laser Tag</div>
                            <div class="text-md truncate leading-none mt-1">30% off with group of 6 people</div>
                            <div class="text-md leading-none text-secondary mt-2">342 followers</div>
                        </div>
                    </div>
                    <div class="flex items-center mt-6">
                        <img
                            class="w-14 h-14 mr-4 rounded object-cover"
                            src="assets/images/cards/sneakers-01-320x200.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="font-medium leading-none">Roadster Clothing Inc.</div>
                            <div class="text-md truncate leading-none mt-1">$25 off on orders $500 and over</div>
                            <div class="text-md leading-none text-secondary mt-2">4.7k followers</div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center mt-6 -mx-3">
                    <button
                        class="px-3"
                        mat-button
                        [color]="'primary'"
                        [routerLink]="['./']">
                        See all groups
                    </button>
                </div>
            </fuse-card> -->

            <!-- News -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4">
                <div class="flex items-center justify-between">
                    <div class="text-2xl font-semibold leading-tight">News</div>
                    <div class="-mr-3">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="listCard01Menu">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                        </button>
                        <mat-menu #listCard01Menu="matMenu">
                            <button mat-menu-item>Mark all as read</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-col mt-5">
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 mt-0.5 mr-2"
                            [svgIcon]="'heroicons_solid:bell'"></mat-icon>
                        <div><b>20% OFF</b> in your favorite hats shop on next Friday.</div>
                    </div>
                    <div class="flex mt-5">
                        <mat-icon
                            class="icon-size-5 mt-0.5 mr-2"
                            [svgIcon]="'heroicons_solid:bell'"></mat-icon>
                        <div>Upcoming meetups within 20 miles.
                            <a
                                class="text-secondary whitespace-nowrap hover:underline"
                                [routerLink]="['./']">See details
                            </a>
                        </div>
                    </div>
                    <div class="flex mt-5">
                        <mat-icon
                            class="icon-size-5 mt-0.5 mr-2"
                            [svgIcon]="'heroicons_solid:bell'"></mat-icon>
                        <div>Concerts from your favorite bands available within 100 miles.
                            <a
                                class="text-secondary whitespace-nowrap hover:underline"
                                [routerLink]="['./']">See details
                            </a>
                        </div>
                    </div>
                </div>
                <div class="flex items-center mt-4 -mx-3">
                    <button
                        class="px-3"
                        mat-button
                        [color]="'primary'"
                        [routerLink]="['./']">
                        See all news
                    </button>
                </div>
            </fuse-card> -->

            <!-- Activity Feed -->
            <!-- <fuse-card class="flex flex-col max-w-80 w-full mt-8 px-8 pt-6 pb-4">
                <div class="flex items-center justify-between">
                    <div class="text-2xl font-semibold leading-tight">Activity Feed</div>
                    <div class="-mr-3">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="listCard04Menu">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                        </button>
                        <mat-menu #listCard04Menu="matMenu">
                            <button mat-menu-item>Clear activities</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="flex flex-col mt-5">
                    <div class="flex">
                        <img
                            class="w-10 h-10 mr-4 rounded-full"
                            src="assets/images/avatars/female-01.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="leading-tight">Amelia Edwards commented on John Silverton's photo</div>
                            <div class="text-md leading-none text-secondary mt-2">4 minutes ago</div>
                        </div>
                    </div>
                    <div class="flex mt-8">
                        <img
                            class="w-10 h-10 mr-4 rounded-full"
                            src="assets/images/avatars/male-01.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="leading-tight">Lew Silverton changed his profile photo</div>
                            <div class="text-md leading-none text-secondary mt-2">25 minutes ago</div>
                        </div>
                    </div>
                    <div class="flex mt-8">
                        <img
                            class="w-10 h-10 mr-4 rounded-full"
                            src="assets/images/avatars/male-15.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="leading-tight">Brian Hughes liked your photo</div>
                            <div class="text-md leading-none text-secondary mt-2">3 hours ago</div>
                        </div>
                    </div>
                    <div class="flex mt-8">
                        <img
                            class="w-10 h-10 mr-4 rounded-full"
                            src="assets/images/avatars/female-15.jpg"
                            alt="Card cover image">
                        <div class="flex flex-col min-w-0">
                            <div class="leading-tight">Marleah Eagleston commented on John Silverton's photo</div>
                            <div class="text-md leading-none text-secondary mt-2">Yesterday</div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center mt-6 -mx-3">
                    <button
                        class="px-3"
                        mat-button
                        [color]="'primary'"
                        [routerLink]="['./']">
                        See entire activity feed
                    </button>
                </div>
            </fuse-card> -->

        </div>

        <!-- Column -->
        <div class="flex flex-col items-start">

            <!-- Info -->
            <fuse-card class="flex flex-col max-w-140 w-full p-8 {{ addAllFilters() }}">
                <button class="px-6 mt-8" mat-flat-button [color]="'primary'"
                [routerLink]="['/q', profile.store.online_id]">
                Get a price quote
            </button>

            <a 
                    *ngIf="+profile?.store?.online_status === 10"
                    class="fuse-mat-button-large w-full mt-10"
                    mat-stroked-button
                    [href]="envPubeUrl + '/s/' + profile.store.online_id"
                    [color]="'primary'">
                    Online Store
           </a>
                <hr class="w-full border-t my-6">

                <div class="text-2xl font-semibold leading-tight">Info</div>
                <div class="text-secondary">Store ID {{profile.store.online_id}}</div>
                <div class="mt-4">
                    <div class="prose">
                        <div [innerHTML]="profile.description ">
                        </div>
                    </div>
                </div>

            </fuse-card>

            <fuse-card class="flex flex-col max-w-140 w-full mt-8 {{ addAllFilters() }}" #expandableCard02="fuseCard">
            <div class="flex items-center mx-6 sm:mx-8 mt-6 mb-4">
                <!-- <img
                class="w-10 h-10 rounded-full mr-4"
                src="assets/images/avatars/female-01.jpg"
                alt="Card cover image"> -->
                <div class="flex flex-col">
                    <span class="font-semibold leading-none">Skills</span>
                    <span class="text-sm text-secondary leading-none mt-1">Select a skill to filter.</span>
                </div>
            </div>

            <div class="mx-6 sm:mx-8 mt-2 mb-6">
                <div class="prose">
                    <!-- <mat-chip-list aria-label="Skills">
                        <mat-chip >All</mat-chip>
                        <mat-chip *ngFor="let skill of skills">{{ skill.name }}</mat-chip>
                    </mat-chip-list> -->

                    <!-- <div class="mb-6 sm:mb-12"> -->
                        <mat-button-toggle-group
                            class="flex flex-wrap -m-2"
                            [(ngModel)]="selectedFilter"
                            (change)="onFilterChange($event)">
                            
                            <ng-container *ngFor="let skill of skills">
                                <mat-button-toggle
                                    class="m-2"
                                    [value]="skill.id">
                                    <span class="text-secondary">{{skill.name | titlecase}}</span>
                                    <!-- <span class="ml-1.5 font-medium text-secondary">({{numberOfCards[filter]}})</span> -->
                                </mat-button-toggle>
                            </ng-container>
                        </mat-button-toggle-group>
                    <!-- </div> -->

                </div>
            </div>


        </fuse-card>



            <!-- Portfolios -->
            <fuse-card *ngFor="let hirePortfolio of profile.hirePortfolios"
                class="flex flex-col max-w-140 w-full mt-8 {{ addFilters(hirePortfolio) }}" #expandableCard02="fuseCard">
                <div class="flex items-center mx-6 sm:mx-8 mt-6 mb-4">
                    <!-- <img
                    class="w-10 h-10 rounded-full mr-4"
                    src="assets/images/avatars/female-01.jpg"
                    alt="Card cover image"> -->
                    <div class="flex flex-col">
                        <span class="font-semibold leading-none">{{ hirePortfolio.title }}</span>
                        <!-- <span class="text-sm text-secondary leading-none mt-1">29 minutes ago</span> -->
                    </div>
                </div>

                <!-- IF one image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 1" class="relative mb-4">
                    <img class="h-80 object-cover"
                        src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                        alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                </div>

                <!-- IF two image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 2" class="flex mx-6 sm:mx-8 mb-4">
                    <div class="flex h-80 pr-1"
                        *ngFor="let hirePortfolioImg of hirePortfolio.hirePortfolioImgs; let i = index">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolioImg.id + '/' + hirePortfolioImg.name + '_3x.' + hirePortfolioImg.ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, i)">
                    </div>
                </div>

                <!-- IF three image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 3" class="flex mx-6 sm:mx-8 mb-4">
                    <div class="flex h-80 pr-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                    </div>
                    <div class="flex flex-col pl-1">
                        <div class="flex h-40 pb-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                        </div>
                        <div class="flex h-40 pt-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                        </div>
                    </div>
                </div>

                <!-- IF four image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 4" class="flex mx-6 sm:mx-8 mb-4">
                    <div class="flex flex-col pr-1">
                        <div class="flex h-40 pb-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                        </div>
                        <div class="flex h-40 pt-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                        </div>
                    </div>
                    <div class="flex flex-col pl-1">
                        <div class="flex h-40 pb-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                        </div>
                        <div class="flex h-40 pt-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                        </div>
                    </div>
                </div>

                <!-- IF five image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 5" class="flex flex-col mx-6 sm:mx-8 mb-4">
                    <div class="flex pb-1">
                        <div class="flex h-60 pr-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                        </div>
                        <div class="flex h-60 pl-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                        </div>
                    </div>
                    <div class="flex pt-1">
                        <div class="flex h-40 pr-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                        </div>
                        <div class="flex h-40 px-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                        </div>
                        <div class="flex h-40 pl-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[4].id + '/' + hirePortfolio.hirePortfolioImgs[4].name + '_3x.' + hirePortfolio.hirePortfolioImgs[4].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 4)">
                        </div>
                    </div>
                </div>

                <!-- IF five and more image -->
                <div *ngIf="hirePortfolio.hirePortfolioImgs.length > 5" class="flex flex-col mx-6 sm:mx-8 mb-4">
                    <div class="flex pb-1">
                        <div class="flex h-60 pr-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                        </div>
                        <div class="flex h-60 pl-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                        </div>
                    </div>
                    <div class="flex pt-1">
                        <div class="flex h-40 pr-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                        </div>
                        <div class="flex h-40 px-1">
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                                alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                        </div>
                        <div class="relative flex h-40 pl-1">
                            <div class="absolute flex items-center justify-center inset-0 ml-1 rounded overflow-hidden">
                                <span class="z-10 text-4xl text-white">+{{ hirePortfolio.hirePortfolioImgs.length
                                    }}</span>
                                <span class="absolute w-full h-full bg-primary opacity-70"></span>
                            </div>
                            <img class="rounded object-cover"
                                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + profile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[4].id + '/' + hirePortfolio.hirePortfolioImgs[4].name + '_3x.' + hirePortfolio.hirePortfolioImgs[4].ext }}"
                                alt="Card cover image">
                        </div>
                    </div>
                </div>

                <div class="mx-6 sm:mx-8 mt-2 mb-6">
                    <div class="prose">
                        <div [innerHTML]="hirePortfolio.description ">
                        </div>
                        <!-- {{hirePortfolio.description}} -->
                    </div>
                </div>
            </fuse-card>

        </div>

    </div>

</div>